/*eslint-disable */
export default {
  name: 'uploadsolution',
  components: {},
  props: {
    showDescription: {
      type: Boolean
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    showBlogDescription() {
      this.$emit('showDescription', false);
    }
  },
  beforeCreate: function() {
    document.title = ' Oddvega - Upload Solutions';
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}